import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { LaunchListDto } from '@rhcst/shared';
import { api } from '../lib/api.js';

export function Launches() {
  const [cursor, setCursor] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(0);
  const [data, setData] = useState<LaunchListDto | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(false);
    void api.get<LaunchListDto>(`/launches?limit=50${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`, controller.signal)
      .then(result => { if (!controller.signal.aborted) setData(result); })
      .catch(() => { if (!controller.signal.aborted) setError(true); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [cursor, refresh]);
  return <div className="shell-content">
    <section className="panel" aria-busy={loading}>
      <div className="panel-head"><h2 className="panel-title">Token launches</h2>
        <button type="button" disabled={loading} onClick={() => { setCursor(null); setRefresh(n => n + 1); }}>Refresh newest</button></div>
      <p className="notice">Launches are shown even before a DEX pool exists. Discovery is not a safety verdict. Unknown evidence does not mean safe.</p>
      {error ? <p role="alert">Could not load launches. Please retry.</p> : null}
      {loading ? <p role="status">Loading launches…</p> : null}
      {!loading && !error && !data?.items.length ? <p>No recorded launches yet.</p> : null}
      {!loading && !error ? <div className="table-scroll" tabIndex={0} role="region" aria-label="Token launch observations"><table className="ptable"><thead><tr>
        <th scope="col">Token</th><th scope="col">Source evidence</th><th scope="col">Lifecycle</th><th scope="col">Observed activity</th><th scope="col">Pools</th>
      </tr></thead><tbody>{data?.items.map(token => <tr key={token.id}>
        <td><strong>{token.symbol ?? token.name ?? 'Unknown metadata'}</strong><br /><code style={{ overflowWrap: 'anywhere' }}>{token.address}</code>{token.blocklisted ? <p>Blocklisted</p> : null}</td>
        <td>{token.origin_platform ?? 'Unknown'}<br />{token.origin_confidence ?? 'Unverified'}</td>
        <td>{token.lifecycle ?? 'Unclassified'}</td>
        <td>{!token.flow ? 'Not measured' : token.flow.stale || !token.flow.coverage_complete ? 'Incomplete or stale — not approval evidence' : `${token.flow.unique_buyers} buying addresses / ${token.flow.buys} buys / ${token.flow.sells} sells`}
          {token.demand_refusals.length ? <details><summary>Demand refusals ({token.demand_refusals.length})</summary><ul>{token.demand_refusals.map((reason, index) => <li key={index}>{reason}</li>)}</ul></details> : null}</td>
        <td>{token.pools.length ? token.pools.map(pool => <div key={pool.id}><Link to={`/pairs/${pool.id}`}>{pool.address.slice(0, 10)}…</Link></div>) : 'No DEX pool recorded'}{token.more_pools ? <p>Showing four linked pools.</p> : null}</td>
      </tr>)}</tbody></table></div> : null}
      <button type="button" disabled={loading || !data?.next_cursor} onClick={() => setCursor(data?.next_cursor ?? null)}>Older launches</button>
    </section>
  </div>;
}
